/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { Helmet } from "react-helmet";

const ModalTuttiBrand = ({ config, visible, requestClose }) => {

    const onExitTap = () => {
        if (requestClose) {
            requestClose();
        }
    }

    return (
        visible &&
        <>
            <Helmet>
                <body style={{overflow:'hidden'}} />
            </Helmet>
            <div className="items-center justify-center" style={{ position: 'fixed', left: 0, top: 0, bottom: 0, right: 0, backgroundColor: 'rgba(255,255,255,0.8)', display: 'flex', overflowY: 'auto' }}>
                <div className="mt-8 bg-white p-4" style={{ display: 'inline-block' }}>
                    <button className="text-third font-rg text-6 float-right" onClick={() => { onExitTap() }}>X</button>

                    <div className="px-16 flex flex-col">
                        <div className="text-primary font-bd text-2 mt-4">Tutti i brand convenzionati con questo pacchetto</div>
                        <div className="text-black font-rg text-6 text-center mt-10">Grazie a questo pacchetto potrai sfruttare vantaggi esclusivi<br />(prevendite, sconti, ...) su tanti brand prestigiosi:</div>
                        <div className="grid grid-cols-2 gap-4 desktop:grid-cols-3 desktop:gap-8 mt-12">
                            <div style={{ paddingBottom: '30%', border: '1px solid #666666' }}><div style={{ textAlign: 'center' }}>brand</div></div>
                            <div style={{ paddingBottom: '30%', border: '1px solid #666666' }}><div style={{ textAlign: 'center' }}>brand</div></div>
                            <div style={{ paddingBottom: '30%', border: '1px solid #666666' }}><div style={{ textAlign: 'center' }}>brand</div></div>
                            <div style={{ paddingBottom: '30%', border: '1px solid #666666' }}><div style={{ textAlign: 'center' }}>brand</div></div>
                            <div style={{ paddingBottom: '30%', border: '1px solid #666666' }}><div style={{ textAlign: 'center' }}>brand</div></div>
                            <div style={{ paddingBottom: '30%', border: '1px solid #666666' }}><div style={{ textAlign: 'center' }}>brand</div></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}


export default ModalTuttiBrand
